
  import { Component, Vue } from 'vue-property-decorator'

  import { authExternal } from '@/helpers/AuthExternal'

  @Component({ name: 'Auth0LoginRoute' })
  export default class extends Vue {
    error: string | null = null

    created() {
      authExternal.handleRedirectCallback().then(({ error }) => {
        if (error) this.error = error.message
      })
    }
  }
